import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Container, Row } from 'react-bootstrap'

import { logout } from '../actions'
import Profile from '../classes/profile'
import SidebarComponent from '../components/sidebar/SidebarComponent'

/** Renders our 404 page */
 class NotFound extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    topic: PropTypes.object,
    logout: PropTypes.func.isRequired,
    location: PropTypes.object
  }

  render () {
    const style = {
      width: '938px',
      height: '30px',
      color: '#808184',
      fontSize: '30px',
      lineHeight: '36px',
      textAlign: 'center',
      marginTop: '85px',
      marginLeft: '175px'
    }

    const {profile, topic, location} = this.props
    const myLogout = () => this.props.logout()
    return (
      <>
        <SidebarComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          topic={topic}
          logout={myLogout}
          location={location}
        />
        <div className="rightSide">
          <Container>
            <Row style={style}>
              We're sorry, but the page you're looking for is unavailable.
            </Row>
          </Container>
        </div>
      </>
    )
  }
}

function mapStateToProps () {
  return {}
}

function mapDispatchToProps (dispatch) {
  return {
    logout: () => dispatch(logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotFound)
